import { render, staticRenderFns } from "./SingleSliderComponent.vue?vue&type=template&id=35937c71&"
import script from "./SingleSliderComponent.vue?vue&type=script&lang=ts&"
export * from "./SingleSliderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports